import { combineReducers } from "redux";
import { reducer as formReducer } from "redux-form";
import { reducer as notificationsReducer } from "reapop";
import { loadingBarReducer } from "react-redux-loading-bar";

import overview from "./overview";
import { reducers as pages } from "./pages/actions";
import { reducers as deals } from "./deals/actions";
import { reducers as hotels } from "./hotels/actions";
import { reducers as searchTags } from "./searchTags/actions";
import { reducers as cities } from "./cities/actions";
import authReducer from "../system/store/auth/reducers";
import siteReducer from "../system/store/site/reducers";
import userReducer from "../system/store/Users/reducers";
import { reducers as bookings } from "./bookings/actions";
import { reducers as countries } from "./countries/actions";
import { reducers as cruiseLines } from "./cruiseLines/actions";
import { reducers as ships } from "./ships/actions";
import { reducers as referrers } from "./referrers/actions";
import { reducers as payments } from "./payments/actions";
import { reducers as testReducer } from "./template/actions";
import { reducers as excursions } from "./excursions/actions";
import adminUserReducer from "../system/store/AdminUsers/reducers";
import { reducers as enquiriesDeals } from "./enquiries/deal/actions";
import { reducers as enquiriesCallback } from "./enquiries/callback/actions";
import { reducers as enquiriesHolidays } from "./enquiries/holidays/actions";
import { reducers as enquiriesBuilder } from "./enquiries/itinerary/actions";
import { reducers as blogsReducer } from "./blogs/actions";
import { reducers as dealTypes } from "./DealTypes/actions";
import { reducers as destinationCategories } from "./DestinationCategories/actions";
import { reducers as subCategories } from "./SubCategories/actions";
import { reducers as seo } from "./seo/actions";
import { reducers as activityCategories } from "./activityCategories/actions";
import { reducers as banners } from "./banners/actions";
import { reducers as cruiselinePage } from "./cruiselinePage/actions";

export default combineReducers({
  loadingBar: loadingBarReducer,
  notifications: notificationsReducer(),
  auth: authReducer,
  site: siteReducer,
  form: formReducer,
  adminUser: adminUserReducer,
  user: userReducer,
  test: testReducer,
  deals,
  hotels,
  cities,
  countries,
  pages,
  enquiriesCallback,
  enquiriesHolidays,
  enquiriesBuilder,
  enquiriesDeals,
  referrers,
  payments,
  bookings,
  overview,
  excursions,
  blogs: blogsReducer,
  dealTypes,
  destinationCategories,
  subCategories,
  seo,
  activityCategories,
  cruiseLines,
  ships,
  searchTags,
  banners,
  cruiselinePage
});



// WEBPACK FOOTER //
// ./src/store/reducers.js